import React from "react";
import RangeSelector from "./RangeSelector";

interface BathsRangeSelectorProps {
  value?: [number | undefined, number | undefined];
  onChange?: (value: [number | undefined, number | undefined]) => void;
  showAny?: boolean;
}

const BathsRangeSelector = ({ 
  value, 
  onChange, 
  showAny = true 
}: BathsRangeSelectorProps) => {
  return (
    <RangeSelector
      options={["1", "2", "3", "4", "5+"]}
      value={value}
      onChange={onChange}
      showAny={showAny}
    />
  );
};

export default BathsRangeSelector;